import { render } from "./main.html?vue&type=template&id=1d5780dd&scoped=true&external"
import script from "./main.ts?vue&type=script&lang=js&external"
export * from "./main.ts?vue&type=script&lang=js&external"

import "./main.scss?vue&type=style&index=0&id=1d5780dd&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5780dd"],['__file',"src/view/main/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d5780dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d5780dd', __exports__)) {
    api.reload('1d5780dd', __exports__)
  }
  
  module.hot.accept("./main.html?vue&type=template&id=1d5780dd&scoped=true&external", () => {
    api.rerender('1d5780dd', render)
  })

}


export default __exports__